import Step0ZipcodeChecker from './steps/Step0_ZipcodeChecker'
import Step1OptInForm from './steps/Step1_OptInForm'
import Step2EligibilityDetails from './steps/Step2_EligibilityDetails'
import PFASInjuredParty from './components/PFASInjuredParty'
// Import shared components for remaining steps
import IdentityPreview from '../shared/IdentityPreview'
import Signature from '../shared/Signature'
import FollowUp from '../shared/FollowUp'
import Submit from '../shared/Submit'
import { PFAS_CAMPAIGN_NAME, PFAS_CAMPAIGN_TYPE } from './constants'
import type { CampaignRegistry } from '../campaignRegistry.types'

export const pfasComponents = {
  Step0_ZipcodeChecker: Step0ZipcodeChecker,
  Step1_OptInForm: Step1OptInForm,
  Step2_EligibilityDetails: Step2EligibilityDetails,
  Step3_InjuredParty: PFASInjuredParty,
  Step4_IdentityPreview: IdentityPreview,
  Step5_Submit: Submit,
  Step6_Signature: Signature,
  Step7_FollowUp: FollowUp,
  // Backwards compatibility with legacy component keys
  ZipcodeChecker: Step0ZipcodeChecker,
  PFASOptInForm: Step1OptInForm,
  PFASEligibilityDetails: Step2EligibilityDetails,
  InjuredParty: PFASInjuredParty,
  IdentityPreview: IdentityPreview,
  Submit: Submit,
  Signature: Signature,
  FollowUp: FollowUp,
}

export const pfasRegistry: CampaignRegistry = {
  type: PFAS_CAMPAIGN_TYPE,
  identifiers: [
    PFAS_CAMPAIGN_TYPE,
    PFAS_CAMPAIGN_NAME,
    'PFAS',
    'pfas',
    'PFAS Drinking Water',
    'pfas-drinking-water',
  ],
  stages: [], // Removed hardcoded stages - now loaded from database
  components: pfasComponents,
}

